import {useEffect, useState} from "react";
import {Button, Form, message, QRCode} from "antd";
import {SDrawerOrModal, SGeneralForms} from "shj-components";
import dayjs from "dayjs";

import styles from './AddOrEditSteps/index.module.less'
import {measureSend} from "@/services/crmTool.ts";

export const PushReportModal = (props) => {
  const {open, onClose, record = {}, reload} = props
  const [form] = Form.useForm()
  const [link, setLink] = useState('')

  useEffect(() => {
    if (open) {
      record.id && getLink()
      form.setFieldsValue({
        ...record,
        actualMeasureTime: record.actualMeasureTime ? dayjs(record.actualMeasureTime) : null,
      })
    }
  }, [open]);

  const getLink = () => {
    measureSend(record.id).then(res => {
      const {shortUrl}  = res
      if (shortUrl) {
        setLink(shortUrl || '')
      }
    })
  }

  const onCopy = () => {
    if (!link) return message.error('没有可复制内容')
    navigator.clipboard.writeText(link).then(() => {
      message.success('复制成功');
    });
  }

  return <SDrawerOrModal
      open={open}
      mode={'modal'}
      width={700}
      title={'推送量房报告'}
      onCancel={onClose}
      antdProps={{
        footer: null
      }}
  >
    <SGeneralForms
        formConfig={{form}}
        layout={'vertical'}
        isDetail={true}
        configs={[{
          formItem: [
            {spanCol: 12, label: '商机ID', name: 'trackPlanId'},
            {spanCol: 12, label: '客户名称', name: 'name'},
            {spanCol: 12, label: '客户电话', name: 'phone'},
            {spanCol: 12, label: '实际量房时间', name: 'actualMeasureTime', type: 'dateTime'},
            {spanCol: 12, label: '楼盘地址', name: 'buildingName'},
            {spanCol: 12, label: '量房人员', name: 'userName'},
            {spanCol: 24, label: '说明', name: 'remark',},
            {
              spanCol: 24, label: '二维码', name: 'link',
              customRender: (form) => {
                return link ? <div className={styles.flexColumnCenter} style={{width: 160, margin: '0 auto'}}>
                  <QRCode value={link}/>
                  <Button style={{marginTop: 10}} onClick={onCopy}>复制链接</Button>
                </div> : <></>
              }
            },
          ]
        }]}/>
  </SDrawerOrModal>

}